import { render, staticRenderFns } from "./confirmed-record.vue?vue&type=template&id=1205af45&"
import script from "./confirmed-record.vue?vue&type=script&lang=js&"
export * from "./confirmed-record.vue?vue&type=script&lang=js&"
import style0 from "./confirmed-record.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./confirmed-record.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports